// import { IJob, JobStatus } from "../../../redux/progress/job/jobReducer";
import { IJob2, Job2Status } from "../../../redux/progress/job2/job2Interface";

export function useJobStatus(job: IJob2): [Job2Status, string] {
    if (!job) {
        return [Job2Status.waiting, "#f24c4c"]
    }

    switch (job.status) {
        case Job2Status.waiting:
            // return [Job2Status.waiting, "red"];

        return [Job2Status.waiting, "#f24c4c"];
        case Job2Status.queue:
            return [Job2Status.queue, "#8B8B00"];
        case Job2Status.running:
            return [Job2Status.running, "#CDCD00"];
        case Job2Status.error:
            return [Job2Status.error, "#f2914a"];

        // 分片作业完成
        case Job2Status.complete:
            // return [Job2Status.complete, "#07ae04"];

        return [Job2Status.complete, "#37c785"];
        //整个实时计算作业完成
        case Job2Status.allcomplete:
            return [Job2Status.allcomplete, "#37c785"];
            // return [Job2Status.allcomplete, "#07ae04"];
        default:
            return [Job2Status.waiting, "#f24c4c"];
    }
}